###
  Select2 editor
  Options in attribute can be changed dynamically
  Reinit select2 to apply new options
###

class INTENT.widgets.Select2Editor

  @ATTR_NAME: "data-widget-select2-editor"

  constructor: (@el) ->
    @s = @.constructor
    @attr = @s.ATTR_NAME
    @code = @attr.replace 'data-', ''

    @ACTION_SELECT_ALL = 'select-all'
    @ACTION_POPUP_EDITOR = 'popup-editor'

    @init_events()

  parse_options: () =>
    _.filter (@el.attr(@attr) || '').split(',')

  show_action_buttons: (select) =>
    s2 = select.data 'select2'
    results = s2.$dropdown.find ".select2-results"
    if not results.length
      return

    options = @parse_options()
    wrapper = results.find "[#{@attr}-wrapper]"

    # no buttons to show
    if not options.length
      wrapper.remove()
      return

    # buttons already shown
    if wrapper.length
      return

    # create new wrapper and buttons
    wrapper = $ @get_wrapper_html()

    if @ACTION_POPUP_EDITOR in options
      btn_popup_editor = $ @get_popup_editor_btn_html()
      btn_popup_editor.on 'click', (e) =>
        btn = $ e.currentTarget
        if not btn.attr 'disabled'
          @execute_action_popup_editor select, btn
      wrapper.append btn_popup_editor

    if @ACTION_SELECT_ALL in options
      btn_select_all = $ @get_select_all_btn_html()
      btn_select_all.on 'click', (e) =>
        btn = $ e.currentTarget
        if not btn.attr 'disabled'
          @execute_action_select_all select, btn
      wrapper.append btn_select_all

    results.prepend wrapper

  execute_action_popup_editor: (select, btn) =>
    @show_popup_editor select
    select.select2 'close'

  execute_action_select_all: (select, btn) =>
    select.select2 'close'
    values = @get_dropdown_values select
    if not values.length
      return

    s2 = select.data 'select2'
    is_ajax = _.isObject s2.dataAdapter.ajaxOptions

    if is_ajax
      for item, i in values
        if select.find("option[value='#{item.id}']").length
          delete values[i]

    select.select2AppendValues _.filter values


  get_dropdown_values: (select) =>
    values = []

    s2 = select.data 'select2'
    search_string = s2.$container.find('input.select2-search__field').val()
    is_ajax = _.isObject s2.dataAdapter.ajaxOptions

    options = s2.$dropdown.find '.select2-results__options .select2-results__option'
    for option in options
      option_data = $(option).data('data')
      if not _.isObject option_data
        continue

      if option_data.element or is_ajax and search_string != option_data.id
          values.push
            id: option_data.id
            text: option_data.text

    return values

  get_wrapper_html: =>
    """
    <div #{@attr}-wrapper
         class='#{@code}-wrapper'
    ></div>
    """

  get_select_all_btn_html: =>
    """
    <div #{@attr}-action='#{@ACTION_SELECT_ALL}'
        class='btn btn-xs btn-default'
    >
      <i class='fa fa-check-square-o'></i> #{__('widget.select2-editor.btn.select-all')}
    </div>
    """

  get_popup_editor_btn_html: =>
    """
    <div #{@attr}-action='#{@ACTION_POPUP_EDITOR}'
        class='btn btn-xs btn-default'
    >
      <i class='fa fa-pencil'></i> #{__('widget.select2-editor.btn.popup-editor')}
    </div>
    """

  show_popup_editor: (select) =>
    values = select.val() || []
    if typeof values isnt 'string'
      values = values.join('\n')

    popup = @get_popup_editor_dom()
    popup.find("[#{@attr}-#{@ACTION_POPUP_EDITOR}-popup-text]").val values

    title = select.data('placeholder') or ''
    popup.find("[#{@attr}-#{@ACTION_POPUP_EDITOR}-popup-title]").text title
    popup.find('.modal-body').css 'height', ($(window).height() - 280) + 'px';
    popup.data("#{@code}-#{@ACTION_POPUP_EDITOR}-popup-target", select).modal 'show'

  get_popup_editor_dom: =>
    popup = $ "[#{@attr}-#{@ACTION_POPUP_EDITOR}-popup]"
    if not popup.length
      popup = $ @get_popup_editor_html()
      $('body').append popup

      popup.on 'shown.bs.modal', (e) =>
        popup.find("[#{@attr}-#{@ACTION_POPUP_EDITOR}-popup-text]").focus()

      popup.find("[#{@attr}-#{@ACTION_POPUP_EDITOR}-popup-action='apply']").on 'click', (e) =>
        e.preventDefault()
        values = popup.find("[#{@attr}-#{@ACTION_POPUP_EDITOR}-popup-text]").val()
        values = values.split('\n')
        select = popup.data("#{@code}-#{@ACTION_POPUP_EDITOR}-popup-target")
        select.select2SetValues values
        popup.modal 'hide'

    return popup

  get_popup_editor_html: =>
    """
    <div class="modal"
         tabindex="-1"
         role="dialog"
         #{@attr}-#{@ACTION_POPUP_EDITOR}-popup
        >
        <div class="modal-dialog widget-select2-editor-modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                      #{__('widget.select2-editor.popup.title')}
                      <span #{@attr}-#{@ACTION_POPUP_EDITOR}-popup-title></span>
                    </h4>
                    <span class="text-muted">#{__('widget.select2-editor.popup.hint')}</span>
                </div>
                <div class="modal-body">
                  <textarea class="form-control"
                            autofocus
                            #{@attr}-#{@ACTION_POPUP_EDITOR}-popup-text></textarea>
                </div>
                <div class="modal-footer">
                    <button type="button"
                            class="btn btn-primary"
                            #{@attr}-#{@ACTION_POPUP_EDITOR}-popup-action='apply'>
                      #{__('widget.select2-editor.popup.ok')}
                    </button>
                    <button type="button"
                            class="btn btn-link"
                            data-dismiss="modal">
                      #{__('widget.select2-editor.popup.cancel')}
                    </button>

                </div>
            </div>
        </div>
    </div>
    """

  init_events: () =>
    @el.on 'select2:open', (e) =>
      @show_action_buttons @el